import RootState from 'ducks/RootState';
import { transformData } from './utils';

export const getPayments = (state: RootState) => state.payments;

export const getPaymentsAnalytics = (state: RootState) => {
  const { paymentAnalytics } = getPayments(state);

  if (!paymentAnalytics) {
    return null;
  }

  return paymentAnalytics.per_method ? transformData(paymentAnalytics) : null;
};

export const getAssetPaymentPerCountry = (state: RootState) => state.payments.assetPaymentPerCountry;
export const getIsFetchingPayments = (state: RootState) => getPayments(state).isFetching;
export const getPaymentDetailsPerCountry = (state: RootState) => getPayments(state).paymentDetailsPerCountry.perCountry;
export const getTotalPaymentsPerCountry = (state: RootState) => getPayments(state).paymentDetailsPerCountry.total;
export const getIsFetchingPaymentDetailsPerCountry = (state: RootState) =>
  getPayments(state).paymentDetailsPerCountry.isFetching;
